import { render, staticRenderFns } from "./TiedostopankkiItem.vue?vue&type=template&id=c367c4fc"
import script from "./TiedostopankkiItem.vue?vue&type=script&lang=js"
export * from "./TiedostopankkiItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports